import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

class InputRadio extends PureComponent {
  handleRadioChange = e => {
    this.props.onChange(this.props.name, this.props.value);
  };

  render() {
    const {style, name, checked, value, label, className} = this.props;
    return (
      <label className={`input-radio form-check ${className}`} style={style}>
        <input
          className="form-check-input"
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={this.handleRadioChange}/>
        <span className="form-check-label">
          {label}
        </span>
      </label>
    )
  }
}

InputRadio.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

const styles = {};

export default InputRadio;



// WEBPACK FOOTER //
// ./src/components/InputRadio.js